import React, { useMemo } from 'react'
import OriginalMaskedInput from 'react-text-mask'
import styled, { css } from 'styled-components'
import { colors } from '~/design'

const MaskedInputComponent = OriginalMaskedInput as unknown as React.ComponentType<any>

export const inputCSS = css`
  flex: 1;
  border-color: ${({ theme }) => theme.colors.mediumGrey};
  border-width: 1px;
  border-style: solid;
  padding: 0.8rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const Input = styled.input`
  ${inputCSS}
`

export const TextArea = styled.textarea`
  ${inputCSS}
  padding: 0.6rem 1rem 0.2rem 1rem;
`

export const MaskedInput = styled(MaskedInputComponent)`
  ${inputCSS}
`
